//ALL CHARMS COUNT
var allCharmsCountGet = 0;
function allCharmsCount(){
  allCharmsCountGet = 0; // reset before loop
  $('.charms_prd_single.selected').each(function(){
    var charmCountSelected = parseInt($(this).attr('countselected'));
    
    allCharmsCountGet += charmCountSelected;
  })
  // console.log(allCharmsCountGet);
}


/// BUNDLE CHARMS GET
var charmsOptionCount = '';
function charmsCurrentOptionCount(){
   charmsOptionCount = parseInt($('.product-variant__container[optionname="charms"]').val());
}
charmsCurrentOptionCount();

$(document).on('change', '.product-variant__container[optionname="charms"]',function(){
  //  debugger;
   charmsOptionCount = $(this).val();
  //  alert(charmsOptionCount);
  //  if(charmsOptionCount == allCharmsCountGet){
  //      $('.charms_prd_single').addClass('clickstop');
  //  }else {
  //      $('.charms_prd_single').removeClass('clickstop'); 
  //  }
   getAllItemsAddedCount();
   yourChramsBoxCreate();
   setTimeout(()=>{
     removedCharmsCountCorrect();
   },1500)
   
})

// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

//BUNDLE DATE
var bundleDate = $('#custom_bundle_date');

$('product-form form').append(bundleDate);


// console.log(bundleDate);



//SINGLE CHARM CLICK

$(document).on('click', '.charms_prd_single', function(){
  var addcharmElm = $(this).find('.charms_prd_single_for_append').clone();
  if (!$(this).hasClass('clickstop')) {
  charmsCurrentOptionCount();
  // alert(charmsOptionCount);
  
  $(this).addClass('selected');
  
  var prdCount = $(this).attr('countselected');
  var increasePrdCount =  parseInt(prdCount)+1;
  
  $(this).attr('countselected', increasePrdCount);
  allCharmsCount();
  // if(charmsOptionCount==allCharmsCountGet){
  //   $('.charms_prd_single').addClass('clickstop');
  // }
  // alert(prdCount);
  singleCharmCountShow();

  
  
   var $el = $('.your_charms_inner .charm_add_main').not('.charm_added').first();

  if ($el.length) {
    
    $el.addClass('charm_added').append(addcharmElm);
    // $el.append(addcharmElm);
  }
  getAllItemsAddedCount();
  

 }
});

function singleCharmCountShow() {
  $('.charms_prd_single').each(function(){
    var prdCount = parseInt($(this).attr('countselected'));
    var countElem = $(this).find('.count_selected');
    if(prdCount > 0){
      countElem.removeClass('hide');
      countElem.text(prdCount);
    }else {
      countElem.addClass('hide');
      countElem.text(prdCount);
      $(this).removeClass('selected');
    }
  })
}

// YOUR CHARMS BOX

function yourChramsBoxCreate() {
  var appendCharmselement = '';
   var charmsOptionCountCurrent = charmsOptionCount;
   
   var charmsOptionCountAdd = $('.your_charms_inner').attr('charmadd');
   
  //  console.log("charmsOptionCountCurrent", charmsOptionCountCurrent);
  //  console.log("charmsOptionCountAdd", charmsOptionCountAdd);
   setTimeout(() => {
      $('.your_charms_inner').attr('charmadd', charmsOptionCount);
      var getAddCharmLength = $('.charm_add').length;
      // alert("getAddCharmLength: " + getAddCharmLength);
      if(getAddCharmLength == 0){
         for (var i = 1; i <= charmsOptionCountCurrent; i++) {
          var elemenetAdd = `<div id="charm${i}" index="${i}" class="charm_add_main"><div class="charm_add_outer"><div class="charm_add"></div><span>Charm #${i}</span></div></div>`;
          appendCharmselement += elemenetAdd;
          
        }
        // console.log(appendCharmselement);
        $('.your_charms_inner').append(appendCharmselement);
        // alert("zerro elememt");
      }
      if(!getAddCharmLength == 0){
        // debugger;
        charmsOptionCountAdd = parseInt(charmsOptionCountAdd);
        charmsOptionCountCurrent = parseInt(charmsOptionCountCurrent);
        if(charmsOptionCountCurrent>charmsOptionCountAdd){
          //  alert(typeof charmsOptionCountCurrent)
          //  alert(typeof charmsOptionCountAdd)
          //  alert("greater")
           charmsOptionCountAdd = parseInt(charmsOptionCountAdd)+1;
           for (var i = charmsOptionCountAdd; i <= charmsOptionCountCurrent; i++) {
            var elemenetAdd = `<div id="charm${i}" index="${i}" class="charm_add_main"><div class="charm_add_outer"><div class="charm_add"></div><span>Charm #${i}</span></div></div>`;
            appendCharmselement += elemenetAdd;
            
          }
          console.log(appendCharmselement);
          $('.your_charms_inner').append(appendCharmselement); 
        }else {
          //  alert("smaller")
          //  alert(typeof charmsOptionCountCurrent)
          //  alert(typeof charmsOptionCountAdd)
          // alert("charmsOptionCountCurrent: " + charmsOptionCountCurrent);
          // alert("charmsOptionCountAdd: " + charmsOptionCountAdd);
          var removeElement = parseInt(charmsOptionCountCurrent) +1;
          // alert(removeElement);
          for (var i = removeElement; i <= charmsOptionCountAdd; i++) {
             var elemenetRemove = `#charm${i}`;
             console.log(elemenetRemove);
             $(elemenetRemove).remove();
          }
        }
        
        
      }
      
    
   }, 500);
   

}

yourChramsBoxCreate();

// REMOVE ADDED CHARM
$(document).on('click','.your_charms_inner .charm_added .remone',function(){
  $(this).closest('.charm_add_main').removeClass('charm_added');
  $(this).closest('.charm_add_main').find('.charms_prd_single_for_append').remove();
  // singleCharmCountShow();

  // setTimeout(()=> {
    removedCharmsCountCorrect();
  // },300)
  
})


// GET ALL ITEMS ADDED COUNT
function getAllItemsAddedCount(){
  var getAllSelectedCharmCount = 0;
  var selectedCharmOptionCount = parseInt($('.product-variant__container[optionname="charms"]').val());
  
  $('.charms_prd_single.selected').each(function(){
    var getSingleSelectedCharmCount = parseInt($(this).attr('countselected'));
    getAllSelectedCharmCount += getSingleSelectedCharmCount;
  });
  // alert("getAllSelectedCharmCount:" + getAllSelectedCharmCount);
  // alert("selectedCharmOptionCount:" + selectedCharmOptionCount);
  var bundleAddToCardText = `Please Select at Least ${selectedCharmOptionCount} Charms`;
   if(selectedCharmOptionCount == getAllSelectedCharmCount  ){
       $('.charms_prd_single').addClass('clickstop');
       $('.bundle_add_to_cart').addClass('bundle_add_to_cart_clickable');
       $('.bundle_add_to_cart .button__text').text('Add to cart');
   }else {
       $('.charms_prd_single').removeClass('clickstop'); 
       $('.bundle_add_to_cart').removeClass('bundle_add_to_cart_clickable');
       $('.bundle_add_to_cart .button__text').text(bundleAddToCardText);

   }
}
getAllItemsAddedCount()

// REMOVED CHARMS COUNT CORRECT
function removedCharmsCountCorrect(){

  $('.charms_prd_single.selected').each(function(){
    var selectedCharmCount = parseInt($(this).attr('countselected'));
    var selectedCharmUnquieKey = $(this).attr('ptitle');
    var addedCharmCount = 0;
    $('.your_charms_main .charms_prd_single_for_append').each(function(){
      var currentAddedCharmCount = parseInt($(this).attr('count'));
      var currentAddedCharmUnquieKey = $(this).attr('ptitle');
      if(selectedCharmUnquieKey == currentAddedCharmUnquieKey){
        addedCharmCount += currentAddedCharmCount;
      }
    });
    // console.log("addedCharmCount: "+ addedCharmCount);
    // console.log("selectedCharmCount: "+ selectedCharmCount);
    if(selectedCharmCount>addedCharmCount){
      // alert("more showing")
      // var updatedSelectedCharmCount = selectedCharmCount-addedCharmCount;
      // alert(updatedSelectedCharmCount);
      $(this).attr('countselected', addedCharmCount);
    }
  });
  singleCharmCountShow();
  getAllItemsAddedCount();
}

// CUSTTOM ADD TO CART BUTTON
function customAddToCartBtn(){
  
}

$(document).on('click', '.bundle_add_to_cart_clickable', function(){
  $('.bundle_add_to_cart_clickable').addClass('working');
  var items = [];
  var timestamp = Date.now(); 

  // console.log('--- START ---');
  // console.log('Timestamp:', timestamp);
  var bundelIdMain = `<input type="hidden" id="custom_bundle_key" name="properties[Bundle_key_parent]" value="${timestamp}" >`;
  $('.your_charms_inner .charm_added .charms_prd_single_for_append').each(function (i) {
    
    var variantId = $(this).attr('charmid');

    // if(!variantId){
    //   console.error('Missing variantId at index:', i, this);
    // } else {
    //   console.log('variantId found:', variantId);
    // }

    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        Bundle_key_child: timestamp
      }
    });

  });
  
  // if(items.length === 0){
  //   console.error('No items found');
  // } else {
  //   console.log('Items array:', items);
  // }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: items
    },
    success: function (res) {
      $('#custom_bundle_key').remove();
      $('product-form form').append(bundelIdMain);
      // console.log('Added to cart:', res);
      $('.add-to-cart').trigger('click');
      $('.bundle_add_to_cart_clickable').removeClass('working');
    },
    error: function (err) {
      console.log('AJAX Error full object:', err);
      console.log('Status:', err.status);
      console.log('Response:', err.responseText);
      $('.bundle_add_to_cart_clickable').removeClass('working');
    }
  });

});







